import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { FaUserPlus } from "react-icons/fa6";
import "../../Assets/style/components/contact.scss";
import axios from "axios";
import { connect } from "react-redux";
import { setDialedNumberInc } from "../../Redux/Actions/actions";
import { AvcUrl, BaseUrl } from "../../Container/BaseUrl/BaseUrl";
import Avatar from "@mui/material/Avatar";
import { MdEmail, MdCall } from "react-icons/md";
import IconButton from "@mui/material/IconButton";
import { IoLogoWhatsapp } from "react-icons/io";
import { MdModeEdit } from "react-icons/md";
import { LuLanguages } from "react-icons/lu";
import { AiOutlineUserDelete, AiOutlineUser } from "react-icons/ai";
import { MdOutlineMail } from "react-icons/md";
import { HiOutlineDevicePhoneMobile } from "react-icons/hi2";
import { FiType } from "react-icons/fi";
import { HiOutlineOfficeBuilding } from "react-icons/hi";
import { PiCity } from "react-icons/pi";
import { HiOutlineBuildingLibrary } from "react-icons/hi2";
import { GrMapLocation } from "react-icons/gr";
import { MdOutlineLocationOn } from "react-icons/md";

import {
  Stack,
  Button,
  Typography,
  Pagination,
  Paper,
  Fab,
  Box,
  Grid,
  Tooltip,
  Switch,
} from "@mui/material";
import AddCustomer from "./AddCustomer";
import EditCustomer from "./EditCustomer";
import NoSelectContact from "../../Assets/images/svg/nouser.svg";
import { toast } from "react-toastify";
import { randomColors } from "../../Utils/colorpallet";
import SessionHistory from "./SessionHistory";
import WhatsAppInitDialogBox from "./WhatsAppInitDialogBox";
import { useDebounce } from "./hooks";
import { toaststyle } from "../../Utils/toaststyle";
import DncrLogHistory from "./DncrLogHistory";

const StyledPaper = styled(Paper)(({ theme }) => ({
  height: "100%",
  padding: "5px 5px 0px 5px",
  background: "none",
  boxShadow: "none",
  borderRadius: "none",
  overflow: "hidden",
}));
const mapStateToProps = (state) => {
  return { skillset: state.data.skillset };
};

const Contact = () => {
  let permission = JSON.parse(localStorage.getItem("permission"));
  const [searchvalue, setsearchvalue] = useState("");
  const [contactList, setContactList] = useState([]);
  const [showAddCustomer, setshowAddCustomer] = useState(false);
  const [showEditCustomer, setsetshowEditCustomer] = useState(false);
  const [selectedUser, setselectedUser] = useState([]);
  const [selectedIndex, setselectedIndex] = useState();
  const [showTab, setshowTab] = useState("Overview");
  const [showUserContactDetail, setshowUserContactDetail] = useState(false);
  const [whatsappOpenDialog, setwhatsappOpenDialog] = useState(false);
  const [pagination, setPagination] = useState(0);
  const [page, setPage] = useState(1);
  const [dncrstatus, setdncrStatus] = useState(false);

  const debouncedSearch = useDebounce(searchvalue);
  const handleChange = (event, value) => {
    setPage(value);
  };
  const whatsappDialogClose = () => {
    setwhatsappOpenDialog(false);
  };


  useEffect(() => {
    if (selectedUser && selectedUser.DNCR_FLAG !== undefined) {
      setdncrStatus(selectedUser.DNCR_FLAG);
    }
  }, [selectedUser]);

  useEffect(() => {
    listContact();
  }, [page]);

  const listContact = () => {
    axios
      .post(
        BaseUrl + "/users/listcustomer",
        { offset: page == 1 ? 0 : (page - 1) * 10, limit: 10 },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setContactList(res.data.data);
          setPagination(res.data.count);
        }
      })
      .catch((err) => {});
  };


  const updateDncrStatus = (value) => {
    let agent_id = JSON.parse(localStorage.getItem("tokenAgent"));
    axios
      .post(
        BaseUrl + "/users/updatedncr",
        { 
          unique_id:selectedUser.id,
          agent_id:agent_id.agent_id,
          dncrflag:value
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          toast.success('DNCR Status Updated Successfully', toaststyle);
          listContact()
        }
      })
      .catch((err) => {});
  };



  const getcustomerdetails = () => {
    axios
      .post(
        BaseUrl + "/users/getcustomerdetails",
        { emailId: debouncedSearch, phonenumber: debouncedSearch },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          setContactList(res.data.data);
          setPagination(res.data.count);
        } else {
          setContactList([]);
          setPagination(0);
        }
      })
      .catch((err) => {});
  };

  const makeCall = (calledNo, type, id) => {
    localStorage.setItem("callActivate", "true");
    localStorage.setItem("CallMadeFromDcc", "true");
    let agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");
    props.setDialedNumberInc(calledNo);
    localStorage.setItem("ClickeToCallPhoneNum", calledNo);
    localStorage.setItem("dailedNumber", calledNo);
    axios
      .post(
        AvcUrl +
          `/voice/terminal/${agentLoginTerminalId}/createContact/sip:${agentLoginTerminalId}@demoaccs.com/sip:${calledNo}@${localStorage.getItem(
            "AvayaDomain"
          )}`,
        {},
        {
          headers: {
            ssoToken: localStorage.getItem("ssoToken"),
          },
        }
      )
      .then((res) => {
        if (res.data.statusCode == 500) {
          toast.warn(res.data.status, toaststyle);
        } else if (res.data.status == "OK") {
          localStorage.setItem("type", type);
          localStorage.setItem("ContactVoiceId", id);
          localStorage.setItem("ClickToCall", "true");
        }
      })
      .catch((err) => {});
  };

  const CrmPopup = (phonenumber, userid) => {
    axios
      .post(
        BaseUrl + "/ticket/crmscreenpop",
        {
          phonenumber: phonenumber,
          skillset: "English",
          channel: "webchat",
          callid: userid,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        window.open(res.data.data);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (searchvalue.length > 2) {
      getcustomerdetails();
    } else if (searchvalue.length == 0) {
      listContact();
    }

    return () => {};
  }, [debouncedSearch]);

  console.log("hgfjkdsjfdk", selectedUser);

  return (
    <StyledPaper>
      <Box
        sx={{
          height: "calc(100% - 40px)",
          width: "100%",
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Grid container>
          {/* contact list  */}
          <Grid item md={3} className="border-end">
            {/* conatct head  */}
            <Stack
              className="p-2 border-bottom"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={0.5}
            >
              {/* conatct title  */}
              <Stack>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#0b3363",
                  }}
                >
                  CMS Contacts
                </Typography>
              </Stack>
              {/* add conatct  */}
              <Stack direction={"row"}>
                <Button
                  sx={{ textTransform: "Capitalize", fontSize: "12px" }}
                  size="small"
                  variant="contained"
                  disableElevation
                  startIcon={<FaUserPlus size={11} />}
                  onClick={() => {
                    setshowAddCustomer(true);
                  }}
                >
                  Customer
                </Button>
              </Stack>
            </Stack>
            {/* contact search list  */}
            <Box className="p-2 cont-search">
              <Box className="nav-item w-100">
                <form className="rounded position-relative">
                  <input
                    autocomplete="off"
                    className="form-control fs-13 bg-light"
                    type="search"
                    name="content"
                    placeholder="Search Customer"
                    aria-label="Search"
                    onChange={(e) => {
                      setsearchvalue(e.target.value);
                    }}
                  />
                </form>
              </Box>
            </Box>
            {/* contact list  */}
            <Box className="p-2 contacts-list fs-13">
              {contactList.length > 0
                ? contactList.map((user, index) => {
                    return (
                      <div
                        key={user.id}
                        className={
                          selectedUser
                            ? selectedUser.id == user.id
                              ? "contact active"
                              : "contact"
                            : "contact"
                        }
                        onClick={() => {
                          setselectedUser(user);
                          setshowUserContactDetail(true);
                          setselectedIndex(index);
                          setsetshowEditCustomer(false);
                        }}
                      >
                        <div className="d-flex p-1 justify-content-start align-items-center">
                          <div
                            className="animate__animated animate__slideInUp ticket_round rounded-circle me-3"
                            style={{
                              backgroundColor: randomColors[index],
                            }}
                          >
                            {user
                              && user.username?user.username.slice(0, 2).toUpperCase()
                              : user.phonenumber.slice(0, 2)}
                          </div>
                          <div className="animate__animated animate__slideInUp">
                            <div className="cont-name">
                              {user ? user.username.toUpperCase() : ""}
                            </div>
                            <div className="text-muted cont-email">
                              <MdCall className="me-1 fs-10" />
                              {user ? user.phonenumber : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                : "No Contact Found"}
            </Box>
            {/* contact footer  */}
            <Stack
              className="p-2 border-top"
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Pagination
                count={Math.ceil(pagination / 10)}
                page={page}
                onChange={handleChange}
                shape="rounded"
                color="primary"
                size="small"
              />
            </Stack>
          </Grid>
          {/* contact detail  */}
          <Grid item md={9}>
            {showUserContactDetail ? (
              <Box className="cont-details-main w-100 h-100">
                <Box
                  className="cont-details-hed border-bottom p-2"
                  style={{ width: "100%" }}
                >
                  <Grid container spacing={2}>
                    {/* user details  */}
                    <Grid item xs={9}>
                      <Stack
                        className="ps-2"
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={0.5}
                      >
                        <Box>
                          <Avatar
                            className="ticket_round me-2"
                            style={{
                              backgroundColor: randomColors[selectedIndex],
                              fontSize: "18px",
                            }}
                          >
                            {" "}
                            {selectedUser &&  selectedUser.username ?
                              selectedUser.username.slice(0, 2).toUpperCase():
                              selectedUser.phonenumber.slice(0, 2)
                              }
                          </Avatar>
                        </Box>
                        <Stack
                          direction="column"
                          justifyContent="flex-start"
                          alignItems="flex-start"
                        >
                          <Stack className="fw-bold cont-name">
                            {selectedUser
                              ? selectedUser.username.toUpperCase()
                              : ""}
                          </Stack>
                          <Stack
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                          >
                            <Box className="text-muted cont-email me-4 fs-13">
                              <MdEmail className="me-2" />
                              {selectedUser ? selectedUser.email : ""}
                            </Box>
                            <Box className="text-muted cont-email fs-13">
                              <MdCall className="me-2" />
                              {selectedUser ? selectedUser.phonenumber : ""}
                            </Box>
                          </Stack>
                        </Stack>
                      </Stack>
                    </Grid>
                    {/* btn right  */}
                    <Grid item xs={3} container justifyContent="flex-end">
                      <Box className="r_action pe-2">
                        <Stack direction="row" spacing={1}>
                          {permission.map((module) => {
                            if (module.moduleName === "CONTACTS") {
                              const value = module.screen.find(
                                (item) =>
                                  item.screenId === "INTIATE_WHATSAPP" &&
                                  item.read &&
                                  item.write
                              );

                              if (value) {
                                return (
                                  <IconButton
                                    aria-label="fingerprint"
                                    color="success"
                                    sx={{
                                      backgroundColor: "#2e7d320a",
                                    }}
                                    onClick={() => {
                                      setwhatsappOpenDialog(true);
                                    }}
                                  >
                                    <IoLogoWhatsapp />
                                  </IconButton>
                                );
                              } else {
                                return (
                                  <Tooltip
                                    title="Contact Admin"
                                    arrow
                                    placement="top"
                                  >
                                    <IconButton
                                      aria-label="fingerprint"
                                      color="success"
                                      sx={{
                                        backgroundColor: "#2e7d320a",
                                      }}
                                    >
                                      <IoLogoWhatsapp />
                                    </IconButton>
                                  </Tooltip>
                                );
                              }
                            }
                          })}

                          <IconButton
                            aria-label="fingerprint"
                            color="primary"
                            sx={{
                              backgroundColor: "#1976d20a",
                            }}
                            onClick={() => {
                              setsetshowEditCustomer(true);
                            }}
                          >
                            <MdModeEdit />
                          </IconButton>
                        </Stack>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                {/* Main details and tab  */}
                <div
                  className="cont-detail-sub p-3"
                  style={{ width: "100%", height: "calc(100% - 100px)" }}
                >
                  <ul
                    className="nav nav-pills mb-3"
                    id="pills-tab"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <button
                        className="rounded-0 nav-link"
                        style={{
                          backgroundColor:
                            showTab == "Overview"
                              ? randomColors[selectedIndex]
                              : "",
                          color: showTab == "Overview" ? "#ffff" : "#1976D2",
                          boxShadow:
                            showTab == "Overview"
                              ? "rgba(0, 0, 0, 0.4) 0px 5px 6px -3px inset"
                              : "",
                        }}
                        id="pills-home-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-home"
                        type="button"
                        role="tab"
                        aria-controls="pills-home"
                        aria-selected="true"
                        onClick={() => {
                          setshowTab("Overview");
                        }}
                      >
                        Overview
                      </button>
                    </li>

                    {permission.map((module) => {
                      if (module.moduleName === "CONTACTS") {
                        const value = module.screen.find(
                          (item) =>
                            item.screenId === "SESSION_HISTORY" &&
                            item.read &&
                            item.write
                        );

                        if (value) {
                          return (
                            <li className="nav-item" role="presentation">
                              <button
                                className="rounded-0 nav-link"
                                style={{
                                  backgroundColor:
                                    showTab == "Ticket"
                                      ? randomColors[selectedIndex]
                                      : "",
                                  color:
                                    showTab == "Ticket" ? "#ffff" : "#1976D2",
                                  boxShadow:
                                    showTab == "Ticket"
                                      ? "rgba(0, 0, 0, 0.4) 0px 5px 6px -3px inset"
                                      : "",
                                }}
                                id="pills-profile-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-profile"
                                aria-controls="pills-profile"
                                type="button"
                                role="tab"
                                aria-selected="false"
                                onClick={() => {
                                  setshowTab("Ticket");
                                }}
                              >
                                Session History
                              </button>
                            </li>
                          );
                        } else {
                          return (
                            <Tooltip
                              title="Contact Admin"
                              arrow
                              placement="top"
                            >
                              <li className="nav-item" role="presentation">
                                <button
                                  className="rounded-0 nav-link"
                                  style={{
                                    backgroundColor:
                                      showTab == "Ticket"
                                        ? randomColors[selectedIndex]
                                        : "",
                                    color:
                                      showTab == "Ticket" ? "#ffff" : "#1976D2",
                                    boxShadow:
                                      showTab == "Ticket"
                                        ? "rgba(0, 0, 0, 0.4) 0px 5px 6px -3px inset"
                                        : "",
                                  }}
                                  id="pills-profile-tab"
                                  data-bs-toggle="pill"
                                  data-bs-target="#pills-profile"
                                  aria-controls="pills-profile"
                                  type="button"
                                  role="tab"
                                  aria-selected="false"
                                >
                                  Session History
                                </button>
                              </li>
                            </Tooltip>
                          );
                        }
                      }
                    })}

                    {permission.map((module) => {
                      if (module.moduleName === "CONTACTS") {
                        const value = module.screen.find(
                          (item) =>
                            item.screenId === "DNCR_AUDIT_LOG" &&
                            item.read &&
                            item.write
                        );

                        if (value) {
                          return (
                            <li className="nav-item" role="presentation">
                              <button
                                className="rounded-0 nav-link"
                                style={{
                                  backgroundColor:
                                    showTab == "dncrlogs"
                                      ? randomColors[selectedIndex]
                                      : "",
                                  color:
                                    showTab == "dncrlogs" ? "#ffff" : "#1976D2",
                                  boxShadow:
                                    showTab == "dncrlogs"
                                      ? "rgba(0, 0, 0, 0.4) 0px 5px 6px -3px inset"
                                      : "",
                                }}
                                id="pills-profile-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-profile"
                                aria-controls="pills-profile"
                                type="button"
                                role="tab"
                                aria-selected="false"
                                onClick={() => {
                                  setshowTab("dncrlogs");
                                }}
                              >
                                DNCR Audit Report
                              </button>
                            </li>
                          );
                        } else {
                          return (
                            <Tooltip
                              title="Contact Admin"
                              arrow
                              placement="top"
                            >
                              <li className="nav-item" role="presentation">
                                <button
                                  className="rounded-0 nav-link"
                                  style={{
                                    backgroundColor:
                                      showTab == "Ticket"
                                        ? randomColors[selectedIndex]
                                        : "",
                                    color:
                                      showTab == "Ticket" ? "#ffff" : "#1976D2",
                                    boxShadow:
                                      showTab == "Ticket"
                                        ? "rgba(0, 0, 0, 0.4) 0px 5px 6px -3px inset"
                                        : "",
                                  }}
                                  id="pills-profile-tab"
                                  data-bs-toggle="pill"
                                  data-bs-target="#pills-profile"
                                  aria-controls="pills-profile"
                                  type="button"
                                  role="tab"
                                  aria-selected="false"
                                >
                                   DNCR Audit Report
                                </button>
                              </li>
                            </Tooltip>
                          );
                        }
                      }
                    })}

                    {permission.map((module) => {
                      if (module.moduleName === "CONTACTS") {
                        const value = module.screen.find(
                          (item) =>
                            item.screenId === "DNCR_FLAG" &&
                            item.read &&
                            item.write
                        );

                        if (value) {
                          return (
                            <li
                              className="nav-item mx-2 d-flex align-items-center justify-content-center"
                              role="presentation"
                            >
                              <Switch size="small" checked={dncrstatus} color="primary"
                                onChange={(e) => {
                                  const updatedStatus = e.target.checked;
                                  setdncrStatus(updatedStatus);
                                  updateDncrStatus(updatedStatus);
                                }}
                              />
                             <span className="mx-1" style={{fontSize:'12px'}}>DNCR Status</span>
                            </li>
                          );
                        } else {
                          return (
                            <Tooltip
                              title="Contact Admin"
                              arrow
                              placement="top"
                            >
                              <li className="nav-item" role="presentation">
                                <button
                                  className="rounded-0 nav-link"
                                  style={{
                                    backgroundColor:
                                      showTab == "Ticket"
                                        ? randomColors[selectedIndex]
                                        : "",
                                    color:
                                      showTab == "Ticket" ? "#ffff" : "#1976D2",
                                    boxShadow:
                                      showTab == "Ticket"
                                        ? "rgba(0, 0, 0, 0.4) 0px 5px 6px -3px inset"
                                        : "",
                                  }}
                                  id="pills-profile-tab"
                                  data-bs-toggle="pill"
                                  data-bs-target="#pills-profile"
                                  aria-controls="pills-profile"
                                  type="button"
                                  role="tab"
                                  aria-selected="false"
                                >
                                  DNCR Flag
                                </button>
                              </li>
                            </Tooltip>
                          );
                        }
                      }
                    })}
                  </ul>

                  {/* tab content  */}
                  <div className="tab-content" id="pills-tabContent">
                    {(() => {
                      switch (showTab) {
                        case "Overview":
                          return (
                            <div
                              className="tab-pane fade show active"
                              id="pills-home"
                              role="tabpanel"
                              aria-labelledby="pills-home-tab"
                            >
                              <div className="cust_view_modal">
                                <div className="row row-cols-3 p-3">
                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      <AiOutlineUser size={24} />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        First Name
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser
                                          ? selectedUser.username
                                          : ""}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      <AiOutlineUserDelete size={24} />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        Last Name
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser
                                          ? selectedUser.Lastname
                                          : ""}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      <FiType size={22} />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        Type
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser ? selectedUser.Type : ""}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      <HiOutlineDevicePhoneMobile size={22} />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        Mobile Number
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser
                                          ? selectedUser.phonenumber
                                          : ""}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      <MdOutlineMail size={22} weight="bold" />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        Email
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser ? selectedUser.email : ""}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      <LuLanguages size={22} weight="bold" />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        Language
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser
                                          ? selectedUser.Language
                                          : ""}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      <HiOutlineOfficeBuilding size={22} />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        Company
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser
                                          ? selectedUser.company
                                          : ""}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      <PiCity size={22} />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        City
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser ? selectedUser.city : ""}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      <HiOutlineBuildingLibrary size={22} />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        State
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser ? selectedUser.state : ""}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      <MdOutlineLocationOn size={22} />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        Postal Code
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser
                                          ? selectedUser.postalcode
                                          : ""}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      <GrMapLocation size={22} />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        Country
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser
                                          ? selectedUser.country
                                          : ""}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        case "Ticket":
                          return <SessionHistory selectedUser={selectedUser} />;
                        case "dncrlogs":
                          return <DncrLogHistory selectedUser={selectedUser} />;
                        default:
                          return <></>;
                      }
                    })()}
                  </div>
                </div>
              </Box>
            ) : (
              // User not found start
              <div className="text-muted d-flex justify-content-center h-100 flex-column">
                <span className="mx-auto">
                  <img
                    src={NoSelectContact}
                    alt="pic"
                    style={{ width: "20rem", userSelect: "none" }}
                  />
                </span>
                <span className="mx-auto">
                  <h6 className="text-muted mt-2" style={{ fontSize: "13px" }}>
                    User not found
                  </h6>
                </span>
              </div>
              // User not found end
            )}
          </Grid>
        </Grid>
      </Box>

      {showAddCustomer && (
        <AddCustomer
          showAddCustomer={showAddCustomer}
          setshowAddCustomer={setshowAddCustomer}
          listContact={listContact}
        />
      )}
      {showEditCustomer && (
        <EditCustomer
          showEditCustomer={showEditCustomer}
          setsetshowEditCustomer={setsetshowEditCustomer}
          listContact={listContact}
          selectedUser={selectedUser}
          setselectedUser={setselectedUser}
          setshowUserContactDetail={setshowUserContactDetail}
        />
      )}
      {whatsappOpenDialog && (
        <WhatsAppInitDialogBox
          whatsappOpenDialog={whatsappOpenDialog}
          whatsappDialogClose={whatsappDialogClose}
          selectedUser={selectedUser}
        />
      )}
    </StyledPaper>
  );
};

export default connect(mapStateToProps, { setDialedNumberInc })(Contact);
